export default __webpack_public_path__ + "static/media/IMG_2248.c8bed77a.jpg";